import { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import SwimmerRegistration from './pages/SwimmerRegistration';
import Competition from './pages/Competition';
import Results from './pages/Results';
import SplashScreen from './pages/SplashScreen';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import { SwimmingProvider } from './context/SwimmingContext';
import { ToastProvider } from './context/ToastContext';
import { ThemeProvider as CustomThemeProvider } from './theme/ThemeContext';
import { Box } from '@mui/material';
import RouteGuard from './components/RouteGuard';

function App() {
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      const competitionStarted = localStorage.getItem('competitionStarted');
      if (competitionStarted === 'true') {
        const message = 'Há uma competição em andamento. Deseja realmente sair?';
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const handleRouteChange = () => {
      const competitionStarted = localStorage.getItem('competitionStarted');
      const savedState = localStorage.getItem('competitionState');
      const currentPath = window.location.hash.slice(1);
      
      if (currentPath !== '/' && !competitionStarted && !savedState) {
        window.location.replace('#/');
      }
    };

    window.addEventListener('hashchange', handleRouteChange);
    handleRouteChange();

    return () => {
      window.removeEventListener('hashchange', handleRouteChange);
    };
  }, []);

  return (
    <CustomThemeProvider>
      <CssBaseline />
      <ToastProvider>
        <SwimmingProvider>
          <Router>
            <RouteGuard>
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                minHeight: '100vh',
                bgcolor: 'background.default',
                transition: 'background-color 0.3s ease'
              }}>
                <Navigation />
                <Box 
                  component="main" 
                  sx={{ 
                    flex: 1, 
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Routes>
                    <Route path="/" element={<SplashScreen />} />
                    <Route path="/register" element={<SwimmerRegistration />} />
                    <Route path="/competition" element={<Competition />} />
                    <Route path="/results" element={<Results />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Box>
                <Footer />
              </Box>
            </RouteGuard>
          </Router>
        </SwimmingProvider>
      </ToastProvider>
    </CustomThemeProvider>
  );
}

export default App;